import Lara from '@primeuix/themes/lara'
import { definePreset } from '@primeuix/themes'

// This is the base theme for primeNg. We use the Lara theme and change the primary color to our
// "cyan" accent color. We apply overrides on top of it using the "design tokens" in this file, the
// _style-vars.scss and styles.scss.
export const ArpioPreset = definePreset(Lara, {
  primitive: {
    medium: {
      color: '#ebebeb',
    },
    light: {
      color: '#ffffff',
    },
  },
  semantic: {
    primary: {
      50: '#f2fbfc',
      100: '#c2eaef',
      200: '#91dae3',
      300: '#61cad7',
      400: '#30b9ca',
      500: '#00a9be',
      600: '#0090a2',
      700: '#007685',
      800: '#005d69',
      900: '#00444c',
      950: '#002a30',
    },
    colorScheme: {
      light: {
        focusRing: {
          shadow: 'none',
        },
      },
    },
  },
  components: {
    datatable: {
      header: {
        borderWidth: '0',
        padding: '0.5rem',
      },
      headerCell: {
        padding: '0.2rem 0.5rem',
      },
      bodyCell: {
        borderColor: '{medium.color}',
        padding: '0.5rem',
      },
      loadingIcon: {
        size: null, // fix animation when the spinner is smaller than the default icon size
      },
      colorScheme: {
        light: {
          header: {
            background: '{light.color}',
          },
        },
      },
    },
  },
})
